/**
 * Opening greeting — Outfit gradient heading + Inter subtitle, exactly as in
 * index_conversational.html (the welcome-header-block at the top of the feed).
 */
import { useI18n } from "../i18n";

export function WelcomeBlock() {
  const { t } = useI18n();
  return (
    <div className="welcome-header-block">
      <h1 className="welcome-greeting">{t("welcome.greeting")}</h1>
      <p className="welcome-subtitle">
        {t("welcome.subtitle")}
      </p>
    </div>
  );
}
